<p class="p-text-sm-lefts mt-2">
  <strong>
    <!-- <em> -->
    Disclaimer:
    <!-- </em> -->
  </strong>
  {{ disclaimerMsg }}
</p>
